<template>
  <div class="page-container" style="max-width: 720px;margin: 0 auto;">

    <v-card class="flex-grow-1 pa-4 page-card dialog-card" variant="flat">
      <!-- 头像 -->
      <div class="d-flex flex-column align-center justify-center avatar-container">
        <div class="back-btn">
          <v-btn icon="mdi-arrow-left" rounded="circle" variant="flat" @click="onBack"></v-btn>
        </div>
        <v-avatar class="mb-4 avatar-clickable" size="128" @click="onEditAvatar">
          <v-img :src="userStore.avatar" cover></v-img>
          <div class="avatar-hover-mask">
            <v-icon color="white" size="28">mdi-camera</v-icon>
          </div>
        </v-avatar>
        <div class="avatar-edit-tip avatar-clickable" @click="onEditAvatar">
          点击更换头像
        </div>
      </div>

      <v-divider class="mt-4"></v-divider>

      <v-card variant="text">
        <v-card-actions>
          <v-icon color="primary" size="24">mdi-account-edit</v-icon>
          <div class="text-primary-darken-1 mb-1">
            基本信息
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" prepend-icon="mdi-pencil" rounded variant="text" @click="onEdit"
            :disabled="isEditBase || isEditPwd" style="text-transform: none;">
            编辑

            <v-dialog activator="parent" max-width="500" v-model="isEditBase">
              <template v-slot:default="{ isActive }">
                <v-card prepend-icon="mdi-account-edit" text="请输入昵称、手机号和邮箱" title="编辑基本信息" class="dialog-card">
                  <v-form class="pa-4" v-model="baseValid" ref="baseFormRef">
                    <v-text-field v-bind="fieldStyleProps" label="昵称" v-model="data.nickName" />
                    <v-text-field v-bind="fieldStyleProps" :rules="phoneRules" label="手机号" v-model="data.phonenumber" />
                    <v-text-field v-bind="fieldStyleProps" :rules="emailRules" label="邮箱" v-model="data.email" />
                  </v-form>
                  <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <v-btn prepend-icon="mdi-close" rounded variant="text" @click="onCancelBase"
                      class="dialog-action-btn" style="text-transform: none;">
                      取消
                    </v-btn>
                    <v-btn prepend-icon="mdi-content-save" rounded variant="text" @click="onSaveBase"
                      class="dialog-action-btn" style="text-transform: none;">
                      保存
                    </v-btn>
                  </template>
                </v-card>
              </template>
            </v-dialog>
          </v-btn>
        </v-card-actions>
        <v-form>
          <DataCard v-bind="dataCardProps" title="昵称" :value="state.user.nickName" />
          <DataCard v-bind="dataCardProps" title="手机号" :value="state.user.phonenumber || '--'" />
          <DataCard v-bind="dataCardProps" title="邮箱" :value="state.user.email" />
          <DataCard v-bind="dataCardProps" title="组织" :value="orgText" v-if="state.user.dept" />
          <DataCard v-bind="dataCardProps" title="角色" :value="state.roleGroup" />
          <DataCard v-bind="dataCardProps" title="创建时间" :value="state.user.createTime" />
        </v-form>

      </v-card>

      <!-- 密码 -->
      <v-divider class="mt-4"></v-divider>
      <v-card variant="text" class="mt-4">
        <v-card-actions>
          <v-icon color="primary" size="24">mdi-lock</v-icon>
          <div class="text-primary-darken-1 mb-1">
            密码
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" prepend-icon="mdi-pencil" rounded variant="text" :disabled="isEditPwd || isEditBase"
            style="text-transform: none;">
            编辑
            <v-dialog activator="parent" max-width="500" v-model="isEditPwd">
              <template v-slot:default="{ isActive }">
                <v-card prepend-icon="mdi-lock" text="请输入旧密码、新密码和确认密码" title="修改密码" class="dialog-card">
                  <v-form class="pa-4" v-model="pwdValid" ref="pwdFormRef">
                    <v-text-field v-bind="fieldStyleProps" :rules="oldPasswordRules" type="password" label="旧密码"
                      v-model="pwdForm.oldPassword" />
                    <v-text-field v-bind="fieldStyleProps" :rules="newPasswordRules" type="password" label="新密码"
                      v-model="pwdForm.newPassword" />
                    <v-text-field v-bind="fieldStyleProps" :rules="confirmPasswordRules" type="password" label="确认密码"
                      v-model="pwdForm.confirmPassword" />
                  </v-form>
                  <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <v-btn prepend-icon="mdi-close" rounded variant="text" @click="onCancelPwd"
                      class="dialog-action-btn" style="text-transform: none;">
                      取消
                    </v-btn>
                    <v-btn prepend-icon="mdi-content-save" rounded variant="text" @click="onSubmitPwd"
                      class="dialog-action-btn" style="text-transform: none;">
                      保存
                    </v-btn>
                  </template>
                </v-card>
              </template>
            </v-dialog>
          </v-btn>
        </v-card-actions>
        <!-- 显示密码 -->
        <DataCard v-bind="dataCardProps" title="密码" value="******" class="flex-grow-1">
        </DataCard>

      </v-card>

      <!-- LOGO 设置 -->
      <v-divider class="mt-4"></v-divider>
      <v-card variant="text" class="mt-4">
        <v-card-actions>
          <v-icon color="primary" size="24">mdi-image-edit</v-icon>
          <div class="text-primary-darken-1 mb-1">
            LOGO 设置
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" prepend-icon="mdi-pencil" rounded variant="text"
            :disabled="isEditPwd || isEditBase" style="text-transform: none;" @click="onEditLogo">
            编辑
            <v-dialog activator="parent" max-width="500" v-model="isEditLogo">
              <template v-slot:default>
                <v-card prepend-icon="mdi-image-edit" text="上传自定义 LOGO，将展示在系统左侧导航栏" title="修改主页 LOGO"
                  class="dialog-card">
                  <div class="pa-4">
                    <div class="company-logo-container">
                      <div class="company-logo" @click="onPickLogo">
                        <v-img :src="logoPreview" contain v-if="logoPreview"></v-img>
                        <div class="company-logo-upload" v-else>
                          <v-icon color="primary" size="24">mdi-plus</v-icon>
                        </div>
                        <div class="company-logo-mask">
                          <v-icon color="white" size="24">mdi-camera</v-icon>
                        </div>
                      </div>
                      <div class="company-logo-tip">
                        点击图片上传文件，支持 JPG / PNG，建议尺寸 100px*100px，不超过 5MB
                      </div>
                    </div>
                  </div>
                  <template v-slot:actions>
                    <v-btn prepend-icon="mdi-restore" rounded variant="text" @click="onResetLogo"
                      :loading="logoResetting" :disabled="logoUploading" class="dialog-action-btn"
                      style="text-transform: none;">
                      恢复默认
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn prepend-icon="mdi-close" rounded variant="text" @click="onCancelLogo"
                      :disabled="logoUploading || logoResetting" class="dialog-action-btn"
                      style="text-transform: none;">
                      取消
                    </v-btn>
                    <v-btn prepend-icon="mdi-content-save" rounded variant="text" @click="onSaveLogo"
                      :loading="logoUploading" :disabled="!logoFile || logoResetting" class="dialog-action-btn"
                      style="text-transform: none;">
                      保存
                    </v-btn>
                  </template>
                </v-card>
              </template>
            </v-dialog>
          </v-btn>
        </v-card-actions>
        <DataCard v-bind="dataCardProps" title="主页 LOGO" class="flex-grow-1">
          <template v-slot:value>
            <v-img :src="userStore.logo" width="48" height="48" class="logo-thumb"></v-img>
          </template>
        </DataCard>
      </v-card>
    </v-card>
  </div>

</template>

<script setup>
import { ref, reactive, computed } from 'vue'
import useUserStore from '@/store/modules/user'
import DataCard from '@/components/DataCard/index.vue'
import { getUserProfile, updateUserProfile } from "@/api/system/user"
import { updateUserPwd, uploadLogo, uploadAvatar } from "@/api/system/user"
import defLogo from '@/assets/logo/logo.png'
import router from '@/router'

import { eui } from 'ems-ui'

const userStore = useUserStore()
const isEditBase = ref(false)
const isEditPwd = ref(false)
const isEditLogo = ref(false)
const logoFile = ref(null)
const logoPreview = ref('')
const logoUploading = ref(false)
const logoResetting = ref(false)

const valueStyle = {
  fontSize: '16px',
  fontFamily: 'HarmonyOS Sans SC',
  fontWeight: 400,
}

const dataCardProps = {
  titlePosition: 'left',
  valueStyle: valueStyle,
}

const fieldStyleProps = {
  color: 'primary',
  density: 'compact',
  rounded: true,
  variant: 'outlined',
  class: 'mb-3',
}

const data = reactive({
  nickName: '',
  phonenumber: '',
  email: '',
})

const baseFormRef = ref(null)
const baseValid = ref(false)
const phoneRules = [
  value => {
    if (!value) return true
    if (/^1[3-9]\d{9}$/.test(value)) return true
    return '请输入正确的手机号'
  },
]
const emailRules = [
  value => {
    if (!value) return true
    if (/^[\w.-]+@[\w-]+(\.[\w-]+)+$/.test(value)) return true
    return '请输入正确的邮箱地址'
  },
]

const pwdForm = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})

const pwdFormRef = ref('pwdFormRef')
const pwdValid = ref(false)
const oldPasswordRules = [
  value => {
    if (value) return true
    return '请输入当前密码'
  },
]

const newPasswordRules = [
  value => {
    if (value) return true
    return '新密码不能为空'
  },
  value => {
    if (value.length >= 6 && value.length <= 20) return true
    return '新密码长度必须为6到20个字符'
  },
]

const confirmPasswordRules = [
  value => {
    if (value) return true
    return '确认密码不能为空'
  },
  value => {
    if (value === pwdForm.newPassword) return true
    return '新密码与确认密码不一致'
  }
]

const state = reactive({
  user: {},
  roleGroup: '',
  postGroup: ''
});

const orgText = computed(() =>
  [state.user.dept?.deptName, state.postGroup].filter(Boolean).join(' / ')
)

async function getUser() {
  try {
    const response = await getUserProfile();
    state.user = response.data;
    state.roleGroup = response.roleGroup;
    state.postGroup = response.postGroup;

  } catch (error) {
    console.log(error);
  }
}

function onEditAvatar() {
  if (userStore.demoRole) {
    eui.showToast('该功能在演示账号中不可用。', 'message')
    return
  }
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = async (event) => {
    const file = event.target.files[0]
    if (!file) return
    if (!file.type.startsWith('image/')) {
      eui.showToast('请选择图片文件', 'message')
      return
    }
    // 限制图片大小 5MB
    if (file.size > 5 * 1024 * 1024) {
      eui.showToast('图片大小不能超过 5MB', 'message')
      return
    }
    try {
      const formData = new FormData()
      formData.append('avatarfile', file)
      const response = await uploadAvatar(formData)
      const imgUrl = response.imgUrl || response.data?.imgUrl
      if (imgUrl) {
        userStore.avatar = imgUrl
      }
      eui.showToast('头像修改成功', 'success')
    } catch (error) {
      console.log(error)
    }
  }
  input.click()
}

function onEdit() {
  data.nickName = state.user.nickName
  data.phonenumber = state.user.phonenumber
  data.email = state.user.email
  data.deptId = state.user.deptId
  data.userId = state.user.userId
}

function onCancelBase() {
  isEditBase.value = false
}

async function onSaveBase() {
  if (userStore.demoRole) {
    eui.showToast('该功能在演示账号中不可用。', 'message')
    return
  }
  const { valid } = await baseFormRef.value.validate()
  if (!valid) return
  try {
    const response = await updateUserProfile(data)
    isEditBase.value = false
    getUser()
  } catch (error) {
  }
}

function onCancelPwd() {
  isEditPwd.value = false
  pwdForm.oldPassword = ''
  pwdForm.newPassword = ''
  pwdForm.confirmPassword = ''
}

async function onSubmitPwd(event) {
  if (userStore.demoRole) {
    eui.showToast('该功能在演示账号中不可用。', 'message')
    return
  }
  pwdFormRef.value.validate()

  if (pwdValid.value) {
    try {
      await updateUserPwd(pwdForm.oldPassword, pwdForm.newPassword)
      eui.showToast('修改成功', 'success')
      isEditPwd.value = false
      pwdForm.oldPassword = ''
      pwdForm.newPassword = ''
      pwdForm.confirmPassword = ''
    } catch (error) {
    }
  }
}

function onEditLogo() {
  logoFile.value = null
  logoPreview.value = userStore.logo
}

function onPickLogo() {
  if (userStore.demoRole) {
    eui.showToast('该功能在演示账号中不可用。', 'message')
    return
  }
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = (event) => {
    const file = event.target.files[0]
    if (!file) return
    if (!file.type.startsWith('image/')) {
      eui.showToast('请选择图片文件', 'message')
      return
    }
    // 限制图片大小 5MB
    if (file.size > 5 * 1024 * 1024) {
      eui.showToast('图片大小不能超过 5MB', 'message')
      return
    }
    // 释放上一张本地预览，避免 blob URL 泄漏
    revokeLogoPreview()
    logoFile.value = file
    logoPreview.value = URL.createObjectURL(file)
  }
  input.click()
}

// 仅回收本地生成的 blob URL，服务端返回的 http 地址不能 revoke
function revokeLogoPreview() {
  if (logoPreview.value && logoPreview.value.startsWith('blob:')) {
    URL.revokeObjectURL(logoPreview.value)
  }
}

// 恢复默认：把内置的默认 logo 读成 File 交给 logoFile，
// 这样「保存」的 :disabled="!logoFile" 才会解除，默认图也能真正提交到服务端
async function onResetLogo() {
  if (logoResetting.value || logoUploading.value) return
  logoResetting.value = true
  try {
    const res = await fetch(defLogo)
    if (!res.ok) throw new Error(`加载默认 LOGO 失败: ${res.status}`)
    const blob = await res.blob()
    revokeLogoPreview()
    logoFile.value = new File([blob], 'logo.png', { type: blob.type || 'image/png' })
    logoPreview.value = URL.createObjectURL(blob)
  } catch (error) {
    console.error(error)
    eui.showToast('恢复默认图片失败，请重试', 'error')
  } finally {
    logoResetting.value = false
  }
}

function onCancelLogo() {
  revokeLogoPreview()
  logoFile.value = null
  logoPreview.value = ''
  isEditLogo.value = false
}

async function onSaveLogo() {
  if (userStore.demoRole) {
    eui.showToast('该功能在演示账号中不可用。', 'message')
    return
  }
  if (!logoFile.value) return
  logoUploading.value = true
  try {
    const formData = new FormData()
    formData.append('logoFile', logoFile.value)
    const response = await uploadLogo(formData)
    const imgUrl = response.imgUrl || response.data?.imgUrl
    if (imgUrl) {
      userStore.logo = imgUrl
    }
    eui.showToast('LOGO 修改成功', 'success')
    onCancelLogo()
  } catch (error) {
    console.log(error)
  } finally {
    logoUploading.value = false
  }
}


function onBack() {
  router.back()
}

getUser()
</script>

<style scoped lang="scss">
.avatar-container {
  position: relative;
}

.avatar-clickable {
  cursor: pointer;
}

.avatar-hover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.avatar-clickable:hover .avatar-hover-mask {
  opacity: 1;
}

.back-btn {
  position: absolute;
  top: 0;
  left: 0;
}

.avatar-edit-tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

.avatar-edit-btn {
  position: absolute;
  bottom: 0;
  right: 0;
}

:deep(.data-card):hover {
  background: rgba(168, 172, 190, 0.1);
}

.company-logo-container {
  background: #F5F6F8;
  border-radius: 8px;
  padding: 16px;
}

.company-logo {
  width: 100px;
  height: 100px;
  /* 白底：客户的透明 PNG 会透出这一层，用蓝灰色会在 logo 周围形成蓝色光圈 */
  background: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #E3E5EB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/* 三个操作按钮统一用常规文本色，不再用 error/success/primary 语义色 */
.dialog-action-btn {
  color: var(--color-text);
}

.company-logo-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.company-logo:hover .company-logo-mask {
  opacity: 1;
}

.logo-thumb {
  border-radius: 6px;
  flex: 0 0 auto;
}

.company-logo-upload {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.company-logo-tip {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 8px;
}
</style>
